export const SHIFT_LIST_PAGE_PATH = "/shift-list";
